import { botClient, makeServicePlugin, BaseModel } from '@/bot'

class GeofenceGroups extends BaseModel {
  constructor(data, options) {
    super(data, options)
  }
  // Required for $FeathersVuex plugin to work after production transpile.
  static modelName = 'GroupMembers'
  // Define default properties here
  static instanceDefaults() {
    return {
      member_id: null,
      group_id: null,
      in_group: null,
      banned: false,
      kicked_by_id: null,
      join_date: null,
      leave_date: null,
      kick_date: null
    }
  }
}

const servicePath = 'group-members'
const servicePlugin = makeServicePlugin({
  Model: GeofenceGroups,
  service: botClient.service(servicePath),
  servicePath
})

// Setup the client-side Feathers hooks.
botClient.service(servicePath).hooks({
  before: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  after: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  },
  error: {
    all: [],
    find: [],
    get: [],
    create: [],
    update: [],
    patch: [],
    remove: []
  }
})

export default servicePlugin